import React from "react";
import MessageFullWidthBlock from "./MessageFullWidthBlock";
import { closeCircleIcon } from "../../components/constants/icons";

const InvalidSubscription = () => {
    return (
      <div className="container">
        <MessageFullWidthBlock 
            className="myk__stu-invalid_subscription"
            icon={closeCircleIcon}
            title="Sorry!"
            message="Invalid Data! Subscription is not in waiting list!"
        />
      </div>
    );
  }
  
  export default InvalidSubscription;
  